import * as React from 'react'

function Form(props: React.JSX.IntrinsicElements['form']) {
  const ref = React.useRef<HTMLFormElement>(null)

  const handleKeyDown = (event: React.KeyboardEvent<HTMLFormElement>) => {
    if (
      props.onSubmit != null &&
      event.key === 'Enter' &&
      (event.metaKey || event.ctrlKey) &&
      ref.current != null &&
      ref.current.reportValidity()
    ) {
      props.onSubmit(event)
    }
  }

  return (
    <form
      {...props}
      ref={ref} // captures keyDown events from children
      role="presentation"
      onKeyDown={handleKeyDown}
    />
  )
}

export default Form
